import { mustBePresent } from "./utils/blank";

export function addRemoveClass(element, className, add) {
  if (add) {
    element.classList.add(className);
  } else {
    element.classList.remove(className);
  }
}

export function onHoverStateChange(element, callback) {
  element.addEventListener("mouseenter", () => {
    callback(true);
  });

  element.addEventListener("mouseleave", () => {
    callback(false);
  });
}

export function replaceInStyle(element, pattern, replacement) {
  let styleStr = element.getAttribute("style") || "";
  styleStr = styleStr.replace(pattern, "");
  styleStr += replacement;
  element.setAttribute("style", styleStr);
}

export function mustBe(klass, value, name = "value") {
  mustBePresent(value, name);
  if (!(value instanceof klass)) {
    throw new Error(
      `Expected "${name}" to be an instance of ${klass.name}, but got: ${value}`
    );
  }
  return value;
}

export function mustBeIfPresent(klass, value, name = "value") {
  if (value !== undefined && value !== null) {
    mustBe(klass, value, name);
  }
  return value;
}

export const mustBeHtmlElement = mustBe.bind(null, HTMLElement);
export const mustBeHtmlElementIfPresent = mustBeIfPresent.bind(
  null,
  HTMLElement
);
export const mustBeHtmlSelectElement = mustBe.bind(null, HTMLSelectElement);
export const mustBeAnchorElement = mustBe.bind(null, HTMLAnchorElement);
